import colors from '@/assets/styles/_export.scss';
import * as variables from '@/assets/js/variables';
import * as testData from '@/assets/js/testData';

const attachVariables = (Vue, variables, wrappingObject, excludedVariables = []) => {
  const filteredKeys = Object.keys(variables).filter(key => !excludedVariables.includes(key));
  const object = filteredKeys.reduce((total, key) => {
    return Object.defineProperty(total, key, {
      value: Object.freeze(variables[key]),
    });
  }, {});
  const prefixedWrappingObject = `$_${wrappingObject}`;
  Object.assign(Vue.prototype, { [prefixedWrappingObject]: object });
};

export default {
  install(Vue) {
    attachVariables(Vue, variables, 'config');
    attachVariables(Vue, colors, 'colors');
    attachVariables(Vue, testData, 'testData');
  },
};
